import {
  InfoPanelTitle,
  InfoPanelDescription,
  InfoPanelLinks,
  InfoPanelFooter,
} from '@/features/jobs/details/tax-type/tax-prep-organizer/components/InfoPanel'

export function NotaryIncomeInfoContent() {
  return (
    <>
      <InfoPanelTitle>What means notary income?</InfoPanelTitle>
      <InfoPanelDescription>
        <p>
          Tell us if any part of this business&apos;s earnings came from notary
          services, such as notarizing documents or providing official
          signatures.
        </p>
        <p>
          Notary income is reported as business income, but it is usually exempt
          from self-employment tax. Identifying it correctly ensures your tax
          calculation is accurate and avoids overpaying SE tax.
        </p>
      </InfoPanelDescription>
      <InfoPanelFooter>
        <InfoPanelLinks
          links={[
            {
              label: 'IRS guidance for notary income',
              url: 'https://www.irs.gov/instructions/i1040sc',
            },
          ]}
        />
      </InfoPanelFooter>
    </>
  )
}
